(() => {
  const header = document.querySelector("[data-header]");
  const toggle = document.querySelector("[data-menu-toggle]");
  const panel = document.querySelector("[data-mobile-menu]");
  if (!header || !toggle || !panel) return;

  const setScrolled = () => {
    header.classList.toggle("is-scrolled", window.scrollY > 16);
  };

  const closeMenu = () => {
    toggle.setAttribute("aria-expanded", "false");
    panel.hidden = true;
  };

  const openMenu = () => {
    toggle.setAttribute("aria-expanded", "true");
    panel.hidden = false;
  };

  toggle.addEventListener("click", () => {
    const expanded = toggle.getAttribute("aria-expanded") === "true";
    if (expanded) closeMenu();
    else openMenu();
  });

  panel.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", closeMenu);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeMenu();
  });

  window.addEventListener("scroll", setScrolled, { passive: true });
  window.addEventListener("resize", () => {
    if (window.matchMedia("(min-width: 1024px)").matches) closeMenu();
  });

  setScrolled();
})();

(() => {
  const states = document.querySelectorAll("[data-problem-states] li");
  if (!states.length || !("IntersectionObserver" in window)) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  document.documentElement.classList.add("problem-motion");

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle("is-in-view", entry.isIntersecting);
      });
    },
    { threshold: 0.55, rootMargin: "-12% 0px -28% 0px" }
  );

  states.forEach((item) => io.observe(item));
})();

(() => {
  const section = document.querySelector("[data-moves]");
  if (!section || !("IntersectionObserver" in window)) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  document.documentElement.classList.add("moves-motion");

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle("is-in-view", entry.isIntersecting);
      });
    },
    { threshold: 0.28 }
  );

  io.observe(section);
})();

(() => {
  const section = document.querySelector("[data-ami]");
  if (!section || !("IntersectionObserver" in window)) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  document.documentElement.classList.add("ami-motion");

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle("is-in-view", entry.isIntersecting);
      });
    },
    { threshold: 0.28 }
  );

  io.observe(section);
})();

(() => {
  const section = document.querySelector("[data-business]");
  if (!section || !("IntersectionObserver" in window)) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  document.documentElement.classList.add("business-motion");

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add("is-in-view");
      });
    },
    { threshold: 0.28 }
  );

  io.observe(section);
})();

(() => {
  const section = document.querySelector("[data-story]");
  if (!section || !("IntersectionObserver" in window)) return;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!reduce) document.documentElement.classList.add("story-motion");

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add("is-in-view");
      });
    },
    { threshold: 0.14, rootMargin: "0px 0px -10% 0px" }
  );

  io.observe(section);
  section.querySelectorAll(".story-stage").forEach((stage) => io.observe(stage));
})();

(() => {
  const hero = document.querySelector("[data-hero-plate]");
  if (!hero) return;

  const position = hero.getAttribute("data-hero-position");
  if (position) hero.style.setProperty("--hero-position", position);

  const positionWide = hero.getAttribute("data-hero-position-wide");
  if (positionWide) hero.style.setProperty("--hero-position-wide", positionWide);

  const positionUltra = hero.getAttribute("data-hero-position-ultra");
  if (positionUltra) hero.style.setProperty("--hero-position-ultra", positionUltra);

  const desktop = hero.getAttribute("data-hero-desktop");
  if (desktop) {
    const absolute = new URL(desktop, document.baseURI).href;
    hero.style.setProperty("--hero-desktop-image", `url("${absolute}")`);
  }
})();

(() => {
  const section = document.querySelector("[data-moment]");
  if (!section) return;

  const panels = [...section.querySelectorAll("[data-moment-step]")];
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");

  const activate = (index, showAll) => {
    panels.forEach((panel, i) => {
      const on = showAll || i === index;
      panel.classList.toggle("is-active", on);
      panel.setAttribute("aria-hidden", on ? "false" : "true");
      panel.toggleAttribute("inert", !on);
    });
  };

  const update = () => {
    if (reduce.matches) {
      activate(0, true);
      section.style.setProperty("--moment-p", "1");
      return;
    }
    const rect = section.getBoundingClientRect();
    const total = Math.max(section.offsetHeight - window.innerHeight, 1);
    const scrolled = Math.min(Math.max(-rect.top, 0), total);
    const p = scrolled / total;
    section.style.setProperty("--moment-p", p.toFixed(4));
    const steps = [0, 0.15, 0.33, 0.51, 0.67, 0.83];
    let index = 0;
    steps.forEach((start, i) => {
      if (p >= start) index = i;
    });
    activate(index, false);
  };

  update();
  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  if (typeof reduce.addEventListener === "function") {
    reduce.addEventListener("change", update);
  }
})();

